import type { BundleOfferPackageOptionView } from 'selectors/offerPage/bundledOfferPageSelectors'
import { excludeNullOrUndefined } from 'checkout/utils'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import { OFFER_TYPE_HOTEL, OFFER_TYPE_ALWAYS_ON } from 'constants/offer'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import config from 'constants/config'

interface BundleValueUpInternalToView {
  shouldShowValue: Array<boolean>
  showPriceDetails: Array<boolean>
  price: number
  hotelPrice: number
  valuedUpTo: number
  purePrice: number
}

export function getBundleValueUpView(bundleOffer: App.BundleOffer, packageView: BundleOfferPackageOptionView) {
  const data: BundleValueUpInternalToView = {
    shouldShowValue: [],
    showPriceDetails: [],
    price: 0,
    hotelPrice: 0,
    valuedUpTo: 0,
    purePrice: 0,
  }

  for (const option of packageView.options) {
    const offer = bundleOffer.bundledOffers[option.package.offerId]

    if (offer.type === OFFER_TYPE_ALWAYS_ON) {
      const packagesWithIsBaseRate = bundleOffer.packages.map((option) => {
        if (option.isBaseRate && option.offerId === offer.id) {
          return { duration: option.duration, value: option.value, packageId: option.id }
        }
      }).filter(excludeNullOrUndefined)

      const basePackageDuration = packagesWithIsBaseRate.find(
        (packageItem) => packageItem.duration === option.package.duration && packageItem.packageId === option.package.id,
      )

      const baseRateCost = basePackageDuration?.value

      let valuedUpTo: number | null = null

      if (baseRateCost && (baseRateCost + option.package.inclusionsAmount) > option.package.value) {
        const displayedHotelValue = baseRateCost + option.package.inclusionsAmount + packageView.propertyFees
        const displayedHotelDiscountPercent = getValueOffPercent(displayedHotelValue, packageView.hotelPrice)

        if (displayedHotelDiscountPercent > option.hotelDiscountPercent) {
          valuedUpTo = displayedHotelValue
        }
      }

      const showPriceDetails = option.taxesAndFees > 0 || option.propertyFees > 0 || config.agentHub.isEnabled
      const shouldShowValue = option.hotelValue > option.hotelPrice && !option.package.roomRate?.inclusionsHideValue

      data.valuedUpTo = data.valuedUpTo + (valuedUpTo || option.hotelValue)
      data.price = data.price + option.basePrice
      data.hotelPrice = data.hotelPrice + option.hotelPrice

      data.showPriceDetails.push(showPriceDetails)
      data.shouldShowValue.push(shouldShowValue)

      if (option.package.bundleDiscountPercent) {
        data.purePrice = data.purePrice + Number(Number((option.basePrice * 100) / (100 - option.package.bundleDiscountPercent)).toFixed(2))
      } else {
        data.purePrice = data.purePrice + option.hotelPrice
      }
    } else if (offer.type === OFFER_TYPE_HOTEL) {
      const showPriceDetails = option.taxesAndFees > 0 || option.propertyFees > 0 || config.agentHub.isEnabled
      const shouldShowValue = option.hotelValue > option.hotelPrice && offer.shouldDisplayValue

      data.valuedUpTo = data.valuedUpTo + option.hotelValue
      data.price = data.price + option.basePrice
      data.hotelPrice = data.hotelPrice + option.hotelPrice

      data.showPriceDetails.push(showPriceDetails)
      data.shouldShowValue.push(shouldShowValue)

      if (option.package.bundleDiscountPercent) {
        data.purePrice = data.purePrice + Number(Number((option.basePrice * 100) / (100 - option.package.bundleDiscountPercent)).toFixed(2))
      } else {
        data.purePrice = data.purePrice + option.hotelPrice
      }
    }
  }

  const bundleDiscount = data.purePrice > data.price ? getValueOffPercent(data.purePrice, data.price) : 0

  let hotelDiscountPercent = data.valuedUpTo > 0 && data.hotelPrice > 0 ? getValueOffPercent(data.valuedUpTo, data.hotelPrice) : packageView.hotelDiscountPercent

  if (bundleDiscount > 1) {
    hotelDiscountPercent = bundleDiscount
  }

  return {
    shouldShowValue: data.shouldShowValue.every((p) => p),
    showPriceDetails: data.showPriceDetails.some((p) => p),
    valuedUpTo: data.valuedUpTo,
    hotelDiscountPercent,
    shouldShowDiscountPercent: hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE,
  }
}
